import classNames from 'classnames'
import { JSX, useState } from 'react'

import { Button } from 'core-components/library/button'
import { LoaderOverlay } from 'core-components/library/loader'
import { ModalDialog } from 'core-components/library/modalDialog'

import styles from './ConfirmDialog.module.scss'

interface IProps {
  show: boolean
  text: string | JSX.Element
  isWarning?: boolean
  onSubmit: () => void
  onCancel?: () => void
  submitButtonText?: string
  cancelButtonText?: string
  onlySubmitButton?: boolean
  onlyCancelButton?: boolean
}

const ConfirmContent = ({
  text,
  onSubmit,
  isWarning,
  onCancel,
  submitButtonText,
  cancelButtonText,
  onlySubmitButton,
  onlyCancelButton,
}: Omit<IProps, 'show'>) => {
  const [wip, setWip] = useState(false)
  return (
    <div>
      <LoaderOverlay show={wip} />
      <h4
        className={classNames(styles.title, {
          [styles.confirmation]: !isWarning,
          [styles.warning]: isWarning,
        })}
      >
        {isWarning ? 'Warning' : 'Confirmation'}
      </h4>
      <div className={styles.text}>{text}</div>
      <div className={styles.btnWrapper}>
        {onlySubmitButton ? (
          <Button
            className={styles.btnWrapper__btn}
            onClick={async () => {
              setWip(true)
              await onSubmit()
              setWip(false)
            }}
          >
            {submitButtonText || 'Submit'}
          </Button>
        ) : onlyCancelButton ? (
          <Button color="danger" onClick={() => onCancel && onCancel()}>
            {cancelButtonText || 'Cancel'}
          </Button>
        ) : (
          <>
            <Button
              className={styles.btnWrapper__btn}
              onClick={async () => {
                setWip(true)
                await onSubmit()
                setWip(false)
              }}
            >
              {submitButtonText || 'Submit'}
            </Button>
            <Button color="danger" onClick={() => onCancel && onCancel()}>
              {cancelButtonText || 'Cancel'}
            </Button>
          </>
        )}
      </div>
    </div>
  )
}

export const ConfirmDialog = (props: IProps) => {
  const { show, onCancel, ...other } = props

  return (
    <ModalDialog
      size={'sm'}
      onClose={() => onCancel && onCancel()}
      content={ConfirmContent}
      show={show}
      contentProps={{ ...other, onCancel }}
    />
  )
}
